import { styled } from "@mui/material/styles";
import DropdownIconAsset from "assets/images/icons/dropdown.svg";

export const ExpandIcon = styled(DropdownIconAsset, {
  label: "expand-icon",
})`
  width: ${({ theme }) => theme.spacing(1.5)};
  height: ${({ theme }) => theme.spacing(1.5)};
  fill: currentColor;
  transform: rotate(0deg);
  transition: ${({ theme }) => theme.transitions.create("transform")};

  &[disabled] {
    fill: ${({ theme }) => theme.palette.color.gray[60]};
  }

  &.expanded {
    transform: rotate(-180deg);
  }
`;

export const Component = styled("button", { label: "expand-button" })`
  width: ${({ theme }) => theme.spacing(3)};
  height: ${({ theme }) => theme.spacing(3)};
  border-radius: 50%;
  border: ${({ theme }) => theme.spacing(0.25)} solid
    ${({ theme }) => theme.palette.color.primary[90]};
  background-color: ${({ theme }) => theme.palette.color.gray[100]};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  display: inline-flex;
  vertical-align: middle;

  &[disabled] {
    color: ${({ theme }) => theme.palette.color.gray[60]};
    fill: ${({ theme }) => theme.palette.color.gray[60]};
    background-color: ${({ theme }) => theme.palette.color.gray[95]};
    border-color: ${({ theme }) => theme.palette.color.gray[90]};
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.color.primary[100]};
  }

  svg {
    width: ${({ theme }) => theme.spacing(1.25)};
    height: ${({ theme }) => theme.spacing(1.25)};
    fill: ${({ theme }) => theme.palette.color.primary.main};
  }
`;
